import React from "react";
import { useParams, useLoaderData } from "react-router-dom";
import { FullPagePaperLayout } from "../Layouts/FullPagePaperLayout";
import { PageBreadcrumbs, PageSubtitle, PageTitle } from "../Layouts/components/PageTitleContainer";
import { Stack, Button, Select, MenuItem, Box } from "@mui/material";
import { KindMovementRule } from "types/locationManagement/kindMovementRule";
import { LocationManagementLocationKind } from "types/locationManagement/locationKind";
import { FieldControl } from "components/Form/FieldControl";
import { Form } from "components/Form/Form";

const KindMovementRuleForm: React.FC = () => {
  const { kindMovementRuleId } = useParams<{ kindMovementRuleId?: string }>();
  const isEdit = Boolean(kindMovementRuleId);
  const { kindMovementRule, locationKinds } = useLoaderData() as {
    kindMovementRule: KindMovementRule;
    locationKinds: LocationManagementLocationKind[];
  };

  return (
    <FullPagePaperLayout>
      <PageBreadcrumbs
        links={[
          { label: "Admin", path: "/" },
          { label: "Kind Movements", path: "/kind-movements" },
        ]}
      />
      <PageTitle>{isEdit ? "Edit" : "Create"} Kind Movement</PageTitle>
      <PageSubtitle>
        A location kind cannot be moved unless a rule lists the destination kind. A kind with no rule cannot be scanned
        or moved.
      </PageSubtitle>
      <Box sx={{ m: 3 }}>
        <Form method={isEdit ? "PUT" : "POST"} resource="kindMovementRule">
          <Stack direction="column" spacing={2}>
            <FieldControl
              name="fromLocationKindId"
              label="From Location Kind"
              inputProps={{
                defaultValue: kindMovementRule.fromLocationKind?.id || kindMovementRule.fromLocationKindId || "",
              }}
            >
              {({ name, label, defaultValue, labelId }) => (
                <Select name={name} labelId={labelId} defaultValue={defaultValue} label={label} required>
                  <MenuItem value="">Select a location kind</MenuItem>
                  {locationKinds.map((locationKind) => (
                    <MenuItem key={locationKind.id} value={locationKind.id}>
                      {locationKind.name}
                    </MenuItem>
                  ))}
                </Select>
              )}
            </FieldControl>
            <FieldControl
              name="toLocationKindId"
              label="To Location Kind"
              inputProps={{
                defaultValue: kindMovementRule.toLocationKind?.id || kindMovementRule.toLocationKindId || "",
              }}
            >
              {({ name, label, defaultValue, labelId }) => (
                <Select name={name} labelId={labelId} defaultValue={defaultValue} label={label} required>
                  <MenuItem value="">Select a location kind</MenuItem>
                  {locationKinds.map((locationKind) => (
                    <MenuItem key={locationKind.id} value={locationKind.id}>
                      {locationKind.name}
                    </MenuItem>
                  ))}
                </Select>
              )}
            </FieldControl>
            <div>
              <Button type="submit" variant="contained">
                {isEdit ? "Update" : "Create"}
              </Button>
            </div>
          </Stack>
        </Form>
      </Box>
    </FullPagePaperLayout>
  );
};

export default KindMovementRuleForm;
